import OrganizationWorkflowLinkCreate from './OrganizationWorkflowLinkCreate'
import OrganizationWorkflowLinkEdit from './OrganizationWorkflowLinkEdit'

export default {
  create: OrganizationWorkflowLinkCreate,
  edit: OrganizationWorkflowLinkEdit,
}
